import { render, staticRenderFns } from "./colorProviderList.vue?vue&type=template&id=6eb5277c"
import script from "./colorProviderList.vue?vue&type=script&lang=js"
export * from "./colorProviderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports